import React from 'react'
import styled from 'styled-components'

export const Container = styled.div<{ paddingTop?: string }>`
    height: ${props => props.theme.layout.fill};
    width: ${props => props.theme.layout.fill};
    display: grid;
    position: relative;
    background-color: #e0e0e0;
    ${props => !!props.paddingTop && `padding-top: ${props.paddingTop}`}
`

type RawImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
    objectFit?: string
    borderRadius?: string
}

const RawImage = ({ objectFit, borderRadius, ...props }: RawImageProps) => <img {...props} />

export const ImageContainer = styled(RawImage)<{ objectFit?: string; borderRadius?: string }>`
    position: absolute;
    top: 0;
    height: ${props => props.theme.layout.fill};
    border-radius: ${props => props.borderRadius};
    width: ${props => props.theme.layout.fill};
    object-fit: ${props => props.objectFit || 'cover'};
`
